import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/primeng';
import { PageBottomComponent } from './page-bottom.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

@NgModule( {
  imports: [
    CommonModule, DialogModule, FormsModule, RouterModule
  ],
  declarations: [ PageBottomComponent ],
  exports: [ PageBottomComponent ],
} )
export class PageBottomModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/page-bottom/page-bottom.module.ts